<template>
  <CardWithTitle
    :item-id="itemId"
    :request-status="requestStatus"
    :options-data="optionsData"
    @call-option-menu="callOptionMenu"
    @reload="getData"
  >
    <div class="blip-monitoring-count-container">
      <div
        class="blip-monitoring-count-container__value"
      >
        {{ value }}
      </div>
    </div>

    <template #top-right-slot>
      <Badge
        v-if="hasFilterApplied && isEditor"
        type="info"
        :tooltip="$t('components.Badge.label.tooltip.info')"
        :value="$t('components.Badge.label.icon.key')"
        :preset="true"
      />
    </template>
  </CardWithTitle>
</template>

<script>
import CardWithTitle from '@/components/cards/models/CardWithTitle';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
import blipModel from '@/mixins/blip-model';
import Badge from '@/components/Badge';
import cardsModel from '@/mixins/cards-model';
import exportModel from '@/mixins/export-model';

export default {
  name: 'BlipMonitoringTicketsCount',
  components: {
    CardWithTitle,
    Badge,
  },
  mixins: [
    blipModel,
    cardsModel,
    exportModel,
  ],
  props: {
    itemId: {
      type: [String, Number],
      required: true,
    },
    servicePath: {
      type: String,
      required: true,
    },
    monitoringType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      value: '',
    };
  },
  computed: {
    optionsData() {
      return this.baseCardOptions.concat(this.exportOptionsData).sort((actualOption, prevOption) => this.sortMenuOptions(actualOption, prevOption));
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getBlipService',
      'hasNoBlipBotAndContractFiltered',
      'getAppliedCardFilter',
    ]),
    async getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      if (await this.hasNoBlipBotAndContractFiltered(this.itemId)) {
        this.requestStatus = 'emptyBot';
        return;
      }

      this.getBlipService({
        servicePath: this.servicePath,
        itemId: this.itemId,
      })
        .then((response) => {
          if (this.totalResponseItems(response)) {
            this.requestStatus = 'emptyData';
            return;
          }

          this.value = response.map(item => item.resource[this.monitoringType])
            .filter(value => typeof value === 'number' && !isNaN(value))
            .reduce((acc, monitoringType) => acc + monitoringType, 0);

          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = error.message;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  .blip-monitoring-count-container {
    height: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;

    &__value {
      display: flex;
      align-items: flex-end;
      font-size: var(--ds-font-size-xl);
      font-weight: var(--ds-font-weight-semibold);
      white-space: nowrap;
    }
  }
</style>
